'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StockAvailibilitySortPopup = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StockAvailibilitySortPopup, _Component);

    function StockAvailibilitySortPopup(props) {
        (0, _classCallCheck3.default)(this, StockAvailibilitySortPopup);

        var _this = (0, _possibleConstructorReturn3.default)(this, (StockAvailibilitySortPopup.__proto__ || (0, _getPrototypeOf2.default)(StockAvailibilitySortPopup)).call(this, props));

        _this.state = {
            sortDescending: false,
            sortDirectionKey: 'asc'
        };
        return _this;
    }

    (0, _createClass3.default)(StockAvailibilitySortPopup, [{
        key: 'visibilityClassName',
        value: function visibilityClassName() {
            return 'stockAvailibilitySort ' + (this.props.showSort ? '' : 'invisible');
        }
    }, {
        key: 'descendingChange',
        value: function descendingChange(descending) {
            this.setState({ sortDescending: descending });
            var directionKey = descending ? 'desc' : 'asc';
            this.setState({ sortDirectionKey: directionKey });
            this.props.sortFunction(this.props.sortByProp, directionKey);
        }
    }, {
        key: 'sortTypeClassName',
        value: function sortTypeClassName(isDescending) {
            return isDescending && this.state.sortDescending || !isDescending && !this.state.sortDescending ? 'selected' : '';
        }
    }, {
        key: 'getSelectionForSortType',
        value: function getSelectionForSortType(comparedKey) {
            return comparedKey === this.props.sortByProp ? 'selected' : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: this.visibilityClassName(),
                    onMouseOver: function onMouseOver(e) {
                        return e.preventDefault();
                    }, onMouseEnter: function onMouseEnter(e) {
                        return e.preventDefault();
                    },
                    onMouseOut: function onMouseOut(e) {
                        return e.preventDefault();
                    }, onMouseLeave: function onMouseLeave(e) {
                        return e.preventDefault();
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'closeButton', onClick: function onClick(e) {
                            return _this2.props.closePopup(e);
                        } },
                    '\u2715'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'popupHeading' },
                    (0, _localize2.default)("App:Sort")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sortTypeHolder' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sortType' },
                        _react2.default.createElement(
                            'div',
                            { className: 'sortTypeTitle' },
                            (0, _localize2.default)("Common:Alphabetically")
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: this.sortTypeClassName(false), onClick: function onClick() {
                                    return _this2.descendingChange(false);
                                } },
                            (0, _localize2.default)("App:Ascending")
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: this.sortTypeClassName(true), onClick: function onClick() {
                                    return _this2.descendingChange(true);
                                } },
                            (0, _localize2.default)("App:Descending")
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sortType' },
                        _react2.default.createElement(
                            'div',
                            { className: 'sortTypeTitle' },
                            (0, _localize2.default)("App:ByStock")
                        ),
                        _react2.default.createElement(
                            'a',
                            { onClick: function onClick() {
                                    return _this2.props.sortFunction(_this2.props.sortKeys.available, _this2.state.sortDirectionKey);
                                },
                                className: this.getSelectionForSortType(this.props.sortKeys.available) },
                            (0, _localize2.default)("Common:InStock")
                        ),
                        _react2.default.createElement(
                            'a',
                            { onClick: function onClick() {
                                    return _this2.props.sortFunction(_this2.props.sortKeys.comission, _this2.state.sortDirectionKey);
                                },
                                className: this.getSelectionForSortType(this.props.sortKeys.comission) },
                            (0, _localize2.default)("App:ConsignmentStore")
                        ),
                        _react2.default.createElement(
                            'a',
                            { onClick: function onClick() {
                                    return _this2.props.sortFunction(_this2.props.sortKeys.processing, _this2.state.sortDirectionKey);
                                },
                                className: this.getSelectionForSortType(this.props.sortKeys.processing) },
                            (0, _localize2.default)("App:ProcessingAmount")
                        ),
                        _react2.default.createElement(
                            'a',
                            { onClick: function onClick() {
                                    return _this2.props.sortFunction(_this2.props.sortKeys.onTheWay, _this2.state.sortDirectionKey);
                                },
                                className: this.getSelectionForSortType(this.props.sortKeys.onTheWay) },
                            (0, _localize2.default)("App:AmountOnTheWay")
                        )
                    )
                )
            );
        }
    }]);
    return StockAvailibilitySortPopup;
}(_react.Component), _class.propTypes = {
    showSort: _propTypes2.default.bool.isRequired,
    closePopup: _propTypes2.default.func.isRequired,
    sortFunction: _propTypes2.default.func.isRequired,
    sortByProp: _propTypes2.default.string,
    sortKeys: _propTypes2.default.object.isRequired
}, _temp);
exports.default = StockAvailibilitySortPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/StockAvailibilitySortPopup.js
// module id = 906
// module chunks = 0